/**
 * The yoga guides' chart-check form props, shared by the server-rendered shell
 * (YogaChartCheckLazy), the island's BirthDetailsForm and
 * BirthToolFormShell.parity.test.tsx, so every frame before and after the
 * island loads reads the same words. No name field: the answer is the seeker's
 * own chart, and a name adds nothing to it. The birth time is required where
 * the engine rule reads the Lagna (Malavya, Viparita, Neecha Bhanga) and
 * optional where it reads signs only (Gajakesari, Budhaditya).
 */
const YOGA_CHECK_FORM = {
  language: "en",
  submitLabel: "Check My Chart",
  collectName: false,
} as const;

/** One guide's form props: the shared base plus its birth-time rule. */
export function yogaCheckFormProps(requireBirthTime: boolean) {
  return { ...YOGA_CHECK_FORM, requireBirthTime };
}

/**
 * One box for every state of the check's slot: the shell, the loading shell,
 * the live form and the verdict each fill the slot's reserved height (its
 * min-height), so no swap moves the page below it. The action sits at the foot
 * of the box in every state, so an error appearing above it moves nothing
 * already on screen.
 */
export const YOGA_CHECK_FRAME =
  "mx-auto flex w-full max-w-md flex-1 flex-col [&>form]:flex [&>form]:flex-1 [&>form]:flex-col [&>form>:last-child]:mt-auto";

/** The real form's input ids (no heading prop, so BirthDetailsForm's "-default" ids). */
export const YOGA_CHECK_FIELD_IDS = {
  date: "birthDate-default",
  time: "birthTime-default",
  place: "birthPlace-default",
} as const;

/** free_tool_started and calculator_used placement for the guide check. */
export const YOGA_CHECK_PLACEMENT = "yoga_guide_check";
